import { useSelector } from '@state/store'
import { Navigate, Outlet } from 'react-router-dom'
import logo from '@assets/img/logos/logo-ether.png'
import { Box, Stack } from '@mui/material'
import { Link } from 'react-router-dom'
import Text from '@components/Text'

export default function AuthLayout() {
  const isAuth = useSelector(({ auth }) => auth.isAuth)
  if (isAuth) return <Navigate to={{ pathname: '/' }} />
  return (
    <main
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        backgroundColor: '#E2E6F2',
        height: '100vh',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: -300,
          left: -280,
          width: '1100px',
          height: '1100px',
          borderRadius: '50%',
          background: '#d0c7ed',
        }}
      />
      <img
        src={logo}
        alt="logo"
        style={{
          position: 'absolute',
          top: 350,
          left: 170,
          width: '350px',
        }}
      />
      <Outlet />
    </main>
  )
}
